import { CeilingLightIcon } from './CeilingLightIcon';

/**
 * author: GreenTurtwig
 * id C45A21A3-671C-4B1A-B405-D625ECA93C11
 * name ceiling-light
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ceiling-light.svg
 * tags
 * - Home Automation 
 */
export const CeilingLampIcon = CeilingLightIcon;
export default CeilingLampIcon